import React, { useState , useEffect } from 'react';
import cloth_1 from '../assets/images/cloth_1.jpg';
import cloth_2 from '../assets/images/cloth_2.jpg';
import swal from 'sweetalert';

import { Link } from 'react-router-dom';

const Card = (props)=> {
    // const [price , setPrice] = useState(1)
    const [cart , setCart] = useState([])
    const [total , settotal] = useState(0)
    const [total1 , settotal1] = useState(0)
    const [price , setPrice] = useState([1,1,1,1,1,1,1,1,1,1,1,1,1])
    const [peice , setpeice] = useState([1,1,1,1,1,1,1,1,1,1,1,1,1])
    const [discount , setdiscount] = useState([])
    const [promo , setpromo] = useState("")
    const [dis , setdis] = useState(true)
    const [totalpro , settotalpro] = useState(0)




    useEffect(() =>{
        window.scrollTo(0, 0)

       const Inter = setInterval(()=>{
            let data =  JSON.parse(localStorage.getItem("Cart")) 
            if(data)
           setCart(data)
           else      setCart(0)

           let data5 =  JSON.parse(localStorage.getItem("CartPrice")) 
           settotal1(data5)
          
        },3000)

        let data =  JSON.parse(localStorage.getItem("Cart")) 
        if(data){
            setCart(data)
            data.map((res,i)=>{
                peice[i] = res.Pieces
                   price[i] = res.Pieces
               })
        }
        else      setCart(0)

 if (data) {
            var j = 0
            data.map((item,i)=>{
               j = item.Total_Product_Price + j
            })
            settotal1(j)
            localStorage.setItem("CartPrice" ,JSON.stringify(j))
        }
        else{
            settotal1(0)

        }
        // console.log(total,cart,total1)
        // var t = document.getElementById("subtotal")
        // t.innerHTML = "Rs "+j
        // var f = document.getElementById("total")
        // f.innerHTML = "Rs " +j
        fetch("https://student1stop-backend-vercel.vercel.app/AllCreateDisCountPrice",{
          method: "GET",
          headers :  {
          "Content-Type" : "application/json" , 
      } ,
      })
      .then(res7=>res7.json())
      .then(res8=>{
       setdiscount(res8)
      
      })

        return () => clearInterval(Inter);

  },[])
  

// useEffect(() => {
  
//     return () => {
//         clearInterval()
//     }
//   }, [])

  const removeDatas = (item) =>{
    // var data =  JSON.parse(localStorage.getItem("Cart")) 
    //  var j = 0
    // data.map((res,i)=>{
    //     if (res._id === id)
    //      j += res.Product_Price 
    // })
    let data1;
    if(!item.Size){
         data1 = cart.filter((res,i)=>{
            return res._id !== item.id
        })
    }
    else{
         data1 = cart.filter((res,i)=>{
            return res.Size !== item.Size
        })
    }
    localStorage.setItem("Cart" ,JSON.stringify(data1))
    // fetch("https://student1stop-backend-vercel.vercel.app/user-cart-add",{
    //     method: "POST",
    //     headers :  {
    //         "Content-Type" : "application/json" , 
    //     } ,
    //     body : JSON.stringify({
    //         cart : data1 ,
    //         user : JSON.parse(localStorage.getItem("User")) 
    //     })
    // })
    // .then(res=>res.json())
    // .then((res1)=>{ 
    //     console.log(res1);
    // })
        var j = 0
    data1.map((res,i)=>{
        // if (res._id === id)
         j += res.Total_Product_Price
    })
    // let data5 =  JSON.parse(localStorage.getItem("CartPrice"))     
    // total1 =  data5 - total1
    if ( j !== 0){
        localStorage.setItem("CartPrice",JSON.stringify( j))
        settotal1(j)
    }
    else{
        localStorage.setItem("CartPrice",JSON.stringify( 0))
        settotal1(0)

    }
    
    
  }



  const minus=(e)=>{
    if(peice[e] > 1)
    peice[e] = (peice[e] - 1)
    // console.log(peice[e],peice);
    if(dis)
    setdis(true)
    else setdis(false)}
const plus=(e)=>{
    if(peice[e] < 100)
    peice[e] = (peice[e] + 1)
    // console.log(peice[e],peice);
    if(dis)
    setdis(true)
    else setdis(false)


}








const updateCard = (id) =>{
    localStorage.removeItem("CartPrice")
      let data3 =  JSON.parse(localStorage.getItem("Cart")) 
      let arr = []
      arr = peice
  
      const pro = data3.map((res,i)=>{
        if(res.Size_Discounted.length === 0){
            res.Stock_Quantity.map((res1,j)=>{
                if(res.Size === res1){
                    return {
                        ...res , Pieces : arr[i] , Total_Product_Price : res.Price[j] * arr[i] 
                    }
                }
            })
        }
        if(res.Size_Discounted.length > 0){
        res.Stock_Quantity.map((res1,j)=>{
            if(res.Size === res1){
          return {
              ...res , Pieces : arr[i] , Total_Product_Price : res.Size_Discounted * arr[i] 
          }
        }
    })
}
        if(res.Product_Price_Discounted)
          return {
              ...res , Pieces : arr[i] , Total_Product_Price : res.Product_Price_Discounted * arr[i] 
          }
          else 
          return {
              ...res , Pieces : arr[i] , Total_Product_Price : res.Product_Price * arr[i] 
          }
      })
      console.log(pro)
      setCart(pro)
     localStorage.removeItem("Cart")
      localStorage.setItem("Cart",JSON.stringify(pro))
      var j = 0
      pro.map((item,i)=>{
        console.log(item.Total_Product_Price)
         j = item.Total_Product_Price + j
      })
      settotal1(j)
      localStorage.setItem("CartPrice" ,JSON.stringify(j))
      swal("Update!", "Your Cart is Updated!", "success");
  
      // props.history.push("/card")
          
      // }
      
    }
  


    const setCouopon = () =>{
     
  
        const the = discount.filter((res,i)=> res.name === promo)
        if(the.length > 0){
          if( the[0].discount > 1){
            settotalpro(total-the[0].discount)
            localStorage.setItem("discount",JSON.stringify(the[0]))
            swal("Successfully applied Promo Code");
          }
          else{
            console.log(the,promo)
            settotalpro(total - (total/the[0].discount1))
            localStorage.setItem("discount",JSON.stringify(the[0]))
            swal("Successfully applied Promo Code");
          }
        }
        else{
          swal("Plz Enter A Correct Promo Code");
        }
          
        }

  
  const EditCart = (id,e) =>{
    props.history.push("/edit-card/"+id+"/"+e)
    
  }
   
        return (
            <div>
            
                <div className="bg-light py-3">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 mb-0"><Link to="/">Home</Link>  <span className="mx-2 mb-0">/</span> <strong className="text-black">Cart</strong></div>
                        </div>
                    </div>
                </div>

                <div className="site-section">
                    <div className="container">
                        <div className="row mb-5">
                            <div className="col-md-12">
                                <div className="site-blocks-table">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th className="product-thumbnail">Image</th>
                                                <th className="product-name">Product</th>
                                                <th className="product-price">Price</th>
                                                <th className="product-quantity">Quantity</th>
                                                <th className="product-total">Total</th>
                                                <th className="product-total">Edit</th>
                                                <th className="product-remove">Remove</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                        {
                                            cart.length >= 1 ? cart.map((item,i)=>{
                                                    return(
                                                        <tr key={i}>
                                                            <td className="product-thumbnail">
                                                                <img src={item.Product_Image_Upload} className="img-fluid" style={{height:"100px"}}  alt="Image"/>
                                                            </td>
                                                            <td className="product-name">
                                                                <h2 className="h5 text-black">{item.Product_Name}</h2>
                                                            </td>
                                                            {!item.Product_Price ?
                                                            <td>Rs {item.Total_Product_Price /  item.Pieces} Size : {item.Size }</td>
                                                            :
                                                            <td>Rs {item.Total_Product_Price /  item.Pieces }  </td>
                                                            }
                                                            <td>
                                                                <div style={{maxWidth: "100px"}}>

                                                                    <center>
                                                                        <input type="text" className="form-control text-center"  value={item.Pieces} onChange={(e)=>setPrice(e.target.value)}  min="1" max="100" placeholder="" aria-label="Example text with button addon" aria-describedby="button-addon1" />
                                                                    </center>
     
                                                                </div>

                                                            </td>
                                                            <td>Rs {(item.Total_Product_Price /  item.Pieces)* peice[i]}</td>
                                                            <td>
                                                                <div className="input-group mb-3" style={{maxWidth: "120px"}}>
                                                                    <div className="input-group-prepend">
                                                                        <button className="btn btn-outline-primary js-btn-minus" type="button"  onClick={()=>minus(i)}>&minus;</button>
                                                                    </div>
                                                                    <input type="text" className="form-control text-center"  value={peice[i]} placeholder="" aria-label="Example text with button addon" aria-describedby="button-addon1" />
                                                                    <div className="input-group-append">
                                                                        <button className="btn btn-outline-primary js-btn-plus" type="button"  onClick={()=>plus(i)} >&#43;</button>
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            {/* <td><button onClick={()=>EditCart(item._id,i)} className="btn btn-primary btn-sm">Edit</button></td> */}
                                                            <td><button onClick={()=>removeDatas(item)} className="btn btn-primary btn-sm">X</button></td>
                                                        </tr>
                                                    )
                                            }) : <tr><td colSpan="6"><div className="col-sm-12 col-lg-12 mb-12"><center> <h3> No Product in Card</h3></center> </div></td></tr> 
                                       }
                                            
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6">
                                <div className="row mb-6">
                                    {/* <div className="col-md-6 mb-3 mb-md-0">
                                        <button className="btn btn-primary btn-sm btn-block">Update Cart</button>
                                    </div> */}
                                    {/* <div className="col-md-6">
                                        <Link to="/"><button className="btn btn-outline-primary btn-sm btn-block mb-2"> Continue Shopping </button></Link>
                                    </div> */}
                                    <div className="col-md-6">
                                        <button className="btn btn-outline-primary btn-sm btn-block mb-2"  onClick={()=>updateCard()}> Updated Cart </button>
                                    </div>
                                    <div className="col-md-6">
                                         {/* <Link to="/"><button className="btn btn-outline-primary btn-sm btn-block mb-2"> Continue Shopping </button></Link> */}
                                    </div>
                                    <div className="col-md-6">
                                    <input className="stext-104 cl2 plh4 size-117 bor13 p-lr-20 m-r-10 m-tb-5 mt-1 mb-2" style={{border : "3px solid rgb(207, 204, 251)",padding: "5px 14px 5px 35px",width: "200px",borderRadius: "34px"}}  type="text" name="coupon" placeholder="Coupon Code" value={promo} onChange={(e)=>setpromo(e.target.value)} />
                                    </div>
                                    <div className="col-md-6">
                                        <button className="btn btn-outline-primary btn-sm btn-block mb-2"  onClick={()=>setCouopon()}> Apply Promo </button>
                                    </div>
                                </div>
                                {/* <div className="row">
                                    <div className="col-md-12">
                                        <label className="text-black h4" for="coupon">Doctor Prescipsion</label>
                                        <p>buy any Medicines Please upload the file !</p>
                                    </div>
                                    <div className="col-md-8 mb-3 mb-md-0">
                                    <form>
                                        <input type="file" className="form-control py-3" id="coupon" placeholder="Coupon Code" />
                                    </form>
                                    </div>
                                    <div className="col-md-4">
                                        <button className="btn btn-primary btn-sm">Submit</button>
                                    </div>
                                </div> */}
                            </div>
                            <div className="col-md-6 pl-5">
                                <div className="row justify-content-end">
                                    <div className="col-md-7">
                                        <div className="row">
                                            <div className="col-md-12 text-right border-bottom mb-5">
                                                <h3 className="text-black h4 text-uppercase">Cart Totals</h3>
                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="col-md-6">
                                                <span className="text-black">Subtotal</span>
                                            </div>
                                            <div className="col-md-6 text-right">
                                                <strong className="text-black" id="subtotal">Rs : {total1}</strong>
                                            </div>
                                        </div>
                                        <div className="row mb-5">
                                            <div className="col-md-6">
                                                <span className="text-black">Total</span>
                                            </div>
                                            <div className="col-md-6 text-right">
                                                <strong className="text-black" id="total">Rs : {total1}</strong>
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-md-12">
                                                <Link to="/checkout"> <button className="btn btn-primary btn-lg py-3 btn-block">Proceed To Checkout</button></Link>
                                               
                                                {/* { JSON.parse(localStorage.getItem("user main")) ?
                                                <Link to="/checkout"> <button className="btn btn-primary btn-lg py-3 btn-block">Proceed To Checkout</button></Link>
                                                :
                                                <Link to="/user/login"> <button className="btn btn-primary btn-lg py-3 btn-block">Login / SignUp</button></Link>
                                                } */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }


export default Card;